import { useCallback } from 'react'

import { harvestDish, commonStakeERC721EarnBakeHarvest} from '../../sushi/utils'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '../'
import { NFTTYPE } from '../../constants/bakery/nft'
import { userNFTMasterContract } from '../../userType/userNFTMasterContract'

const useHarvestDish = (type?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let dishMasterContract = userNFTMasterContract(sushi, type)
  const handleHarvest = useCallback(async () => {
    try {
      let txHash
      if (type && [
        NFTTYPE.DOGGIES,
        NFTTYPE.DOGGIES_V2,
        NFTTYPE.BARKING,
        NFTTYPE.BARKING_V2,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.EQUIPMENT_V2,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.BAKEMUSKMIXER_V2,
        NFTTYPE.CAR_V2,
        NFTTYPE.COMBO_V2,
        NFTTYPE.SOCCER_V2,
        NFTTYPE.POKER_V2,
        NFTTYPE.DOGGIES_V3,
        NFTTYPE.BARKING_V3,
        NFTTYPE.EQUIPMENT_V3,
        NFTTYPE.BAKEMUSKMIXER_V3,
        NFTTYPE.CAR_V3,
        NFTTYPE.COMBO_V3,
        NFTTYPE.SOCCER_V3,
        NFTTYPE.POKER_V3,
      ].includes(type)) {
        txHash = await commonStakeERC721EarnBakeHarvest(
          dishMasterContract,
          account
        )
      } else {
        txHash = await harvestDish(
          dishMasterContract,
          account
        )
      }
      console.log(txHash)
      return txHash
    } catch (e) {
      return false
    }
  },
  [account, dishMasterContract, type])

  return handleHarvest
}

export default useHarvestDish
